import { Observable } from '../../Observable';
import { concatMapTo } from '../../operator/concatMapTo';
Observable.prototype.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map